import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      richColors
      closeButton
      // On phones toasts stack above the designer's bottom sheet instead of
      // over the panel being edited (the sheet publishes its height; elsewhere
      // the variable is unset and this is sonner's default 16px).
      mobileOffset={{ bottom: 'calc(var(--mobile-sheet-h, 0px) + var(--assistant-launcher-h, 0px) + 16px)' }}
      // Clear of the assistant: above its round launcher, and beside its
      // window while that is open; on the planner also clear of the open
      // edit panel (all three publish their size; elsewhere these are
      // sonner's default 32px).
      offset={{
        bottom: 'calc(var(--assistant-launcher-h, 0px) + 32px)',
        right: 'calc(var(--assistant-panel-w, 0px) + var(--designer-edit-panel-w, 0px) + 32px)',
        left: '32px',
        top: '32px',
      }}
      toastOptions={{
        classNames: {
          // Note: no bg/border/text override here so `richColors` can tint each
          // toast by type (error=red, success=green, warning=amber, info=blue).
          // Default (untyped) toasts fall back to Sonner's themed neutral card.
          toast: "group toast group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
